"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
require("./stripe.scss");
const paymentSlice_1 = require("../../../../redux/slices/paymentSlice");
const cardForm_1 = __importDefault(require("../../modals/card-form/cardForm"));
const common_1 = require("../../../../utils/common");
const stripe_js_1 = require("@stripe/stripe-js");
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const stripe = stripe_js_1.loadStripe(window.AppearMe.appConfigs.stripeApiId);
class Stripe extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            modalOpen: false
        };
        this.handleModalChange = () => {
            this.setState({ modalOpen: !this.state.modalOpen });
        };
    }
    componentDidMount() {
        this.props.getPaymentInfo();
        this.props.showCardForm && this.handleModalChange();
        if (!common_1.ifMobile()) {
            window.history.pushState("", "", '/#/payment-history');
        }
    }
    // redirect to stripe platform
    goToStripe() {
        window.AppearMe.Widgets.Events.emit('onClick', null);
    }
    render() {
        // const payment = this.props.payment;
        const { payment: payment } = this.props.payment;
        const stripeBalance = payment.balance;
        return (react_1.default.createElement(core_1.Box, { id: "stripe-container" },
            react_1.default.createElement("div", { className: "card-box stripe-account-box" },
                stripeBalance && react_1.default.createElement("div", { className: "edit-icon", onClick: () => this.goToStripe() },
                    react_1.default.createElement("span", null, "Edit")),
                react_1.default.createElement("div", { className: "icon-stripe" }),
                !stripeBalance && react_1.default.createElement("p", { className: "text" }, "Tell us where to send your earning."),
                stripeBalance && react_1.default.createElement("p", { className: "text" },
                    "Stripe Account: ",
                    react_1.default.createElement("span", null,
                        "**** ",
                        stripeBalance.last4)),
                stripeBalance && react_1.default.createElement("p", { className: "text" },
                    "Balance: ",
                    react_1.default.createElement("span", null,
                        "$",
                        stripeBalance.availableAmount)),
                !stripeBalance && react_1.default.createElement("button", { className: 'v2-btn v2-btn-quaternary', onClick: () => this.goToStripe() }, "Setup Stripe")),
            react_1.default.createElement("div", { className: "card-box stripe-card-box" },
                payment.customerId && react_1.default.createElement("div", { className: "edit-icon", onClick: this.handleModalChange },
                    react_1.default.createElement("span", null, "Edit")),
                react_1.default.createElement("div", { className: "icon-wrapper" },
                    react_1.default.createElement("div", { className: `icon icon-${payment.cardType || 'card'}` })),
                !payment.customerId && react_1.default.createElement("p", { className: "text" }, "Tell us how you will be paying."),
                payment.customerId && react_1.default.createElement("p", { className: "text" },
                    "Registered Card: ",
                    react_1.default.createElement("span", null,
                        "**** ",
                        payment.last4)),
                !payment.customerId && react_1.default.createElement("button", { className: 'v2-btn v2-btn-quaternary', onClick: this.handleModalChange }, "Setup Card")),
            stripe && react_1.default.createElement(react_stripe_js_1.Elements, { stripe: stripe },
                react_1.default.createElement(react_stripe_js_1.ElementsConsumer, null, ({ elements, stripe }) => (react_1.default.createElement(cardForm_1.default, { modalOpen: this.state.modalOpen, stripe: stripe, elements: elements, toggleModal: this.handleModalChange }))))));
    }
}
const mapStateToProps = (state) => {
    const { payment } = state;
    return {
        payment
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getPaymentInfo: () => dispatch(paymentSlice_1.paymentInfo()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Stripe);
